import React from 'react';
import { Route } from 'react-router-dom';
import hoistNonReactStatics from 'hoist-non-react-statics';
import qs from 'qs';

let cache: Record<string, Record<string, unknown>> = {};
let cacheCount = 0;

export default function withRouter(Component: any) {
  const C = (props: any) => {
    const { wrappedComponentRef, ...rest } = props;

    return (
      <Route
        children={({ location, ...routeRest }: any) => {
          let query: Record<string, unknown> = {};

          if (location.search) {
            if (cache[location.search]) {
              query = cache[location.search];
            } else {
              query = qs.parse(location.search, {
                ignoreQueryPrefix: true,
                comma: true,
              });
              cache[location.search] = query;
              cacheCount += 1;
            }

            if (cacheCount > 500) {
              cache = {};
            }
          }

          const modifiedProps = {
            ...routeRest,
            location: {
              ...location,
              query,
            },
            q: query,
          };

          return (
            <Component
              {...rest}
              {...modifiedProps}
              updateUrl={_updateUrl(query, routeRest.match, routeRest.history)}
              ref={wrappedComponentRef}
            />
          );
        }}
      />
    );
  };

  C.displayName = `withRouter(${Component.displayName || Component.name})`;
  C.wrappedComponent = Component;

  return hoistNonReactStatics(C, Component);
}

function _updateUrl(query: Record<string, unknown>, match: any, history: any) {
  return (
    update: Record<string, unknown> = {},
    method: 'push' | 'replace' = 'replace',
    pathnameOverride?: string
  ) => {
    const modifiedQuery = qs.stringify(
      { ...query, ...update },
      { addQueryPrefix: true, encode: true }
    );

    history[method]({
      pathname: pathnameOverride || match.url.pathname,
      search: modifiedQuery,
    });
  };
}
